// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { fermentationChangesetTriggerEnum } from './FermentationChangesetTriggerEnum';
import { fermentationChangesetStateEnum } from './FermentationChangesetStateEnum';
import { fermentationProtocolId } from './FermentationProtocol';
import { operatorId } from './Operator';
import { brewcontrolRunId } from './BrewcontrolRun';
import { brewcontrolEventId } from './BrewcontrolEvent';
import { fermentationScheduledActionId } from './FermentationScheduledAction';
import { z } from 'zod';
export const fermentationChangesetId = (z.number());
export const fermentationChangeset = z.object({
    id: fermentationChangesetId,
    fermentation_id: fermentationId,
    name: z.string(),
    trigger_kind: fermentationChangesetTriggerEnum,
    trigger_elapsed_s: z.string().nullable(),
    trigger_at: z.date().nullable(),
    effective_at: z.date(),
    state: fermentationChangesetStateEnum,
    rejection: z.string().nullable(),
    source_protocol_id: fermentationProtocolId.nullable(),
    operator_id: operatorId.nullable(),
    reason: z.string().nullable(),
    metadata: z.string().nullable(),
    brewcontrol_run_id: brewcontrolRunId.nullable(),
    armed_event_id: brewcontrolEventId.nullable(),
    fired_event_id: brewcontrolEventId.nullable(),
    removed_event_id: brewcontrolEventId.nullable(),
    legacy_protocol_application_id: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    scheduled_action_id: fermentationScheduledActionId.nullable(),
});
export const fermentationChangesetInitializer = z.object({
    id: fermentationChangesetId.optional(),
    fermentation_id: fermentationId,
    name: z.string(),
    trigger_kind: fermentationChangesetTriggerEnum,
    trigger_elapsed_s: z.string().optional().nullable(),
    trigger_at: z.date().optional().nullable(),
    effective_at: z.date(),
    state: fermentationChangesetStateEnum,
    rejection: z.string().optional().nullable(),
    source_protocol_id: fermentationProtocolId.optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    reason: z.string().optional().nullable(),
    metadata: z.string().optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    armed_event_id: brewcontrolEventId.optional().nullable(),
    fired_event_id: brewcontrolEventId.optional().nullable(),
    removed_event_id: brewcontrolEventId.optional().nullable(),
    legacy_protocol_application_id: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
});
export const fermentationChangesetMutator = z.object({
    id: fermentationChangesetId.optional(),
    fermentation_id: fermentationId.optional(),
    name: z.string().optional(),
    trigger_kind: fermentationChangesetTriggerEnum.optional(),
    trigger_elapsed_s: z.string().optional().nullable(),
    trigger_at: z.date().optional().nullable(),
    effective_at: z.date().optional(),
    state: fermentationChangesetStateEnum.optional(),
    rejection: z.string().optional().nullable(),
    source_protocol_id: fermentationProtocolId.optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    reason: z.string().optional().nullable(),
    metadata: z.string().optional().nullable(),
    brewcontrol_run_id: brewcontrolRunId.optional().nullable(),
    armed_event_id: brewcontrolEventId.optional().nullable(),
    fired_event_id: brewcontrolEventId.optional().nullable(),
    removed_event_id: brewcontrolEventId.optional().nullable(),
    legacy_protocol_application_id: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    scheduled_action_id: fermentationScheduledActionId.optional().nullable(),
});
//# sourceMappingURL=FermentationChangeset.js.map